export default __webpack_public_path__ + "static/banner_shape-cb2385102c3d29109d1537a1f2d17e6e.png";